import React from 'react';
import styles from '../deeborah_martinns/deeborah_martinns.module.scss';
import Background from './src/background-links.png';
import LinkPersonalizado7 from '../../components/LinkPersonalizado7/linkPersonalizado7.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import MagazineIcon from '../../icons/magazineIcon.tsx';

const Deeborah_martinns: React.FC = () => {
    return (
        <div className={styles.deeborah_martinns}>
            <div className={styles["body-thunder"]} style={{
                backgroundImage: `url(${Background})`
            }}>
                <div
                    className={styles["container-thunder"]}
                >
                    <h1 className="pt-2">Deborah Martinns</h1>
                    <div className={styles.links}>
                        <>
                            <LinkPersonalizado7
                                href="https://www.instagram.com/deeborah_martinns?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                                title="INSTAGRAM"
                                icon={<InstagramIcon marginTop={true} height="32" color="#ffffff" />}
                                colorText="#cbb353"
                                spaceBetween={true}
                            />
                            <LinkPersonalizado7
                                href="https://wa.me/5517991391807?text=Olá, gostaria de agendar um horário."
                                title="AGENDAR"
                                icon={<WhatsappIcon height="40" color="#ffffff" />}
                                colorText="#cbb353"
                                spaceBetween={true}
                            />
                            <LinkPersonalizado7
                                href="https://maps.app.goo.gl/SVeWwCeYqiV6TeTP9"
                                title="LOCALIZAÇÃO"
                                icon={<MapsIcon height="38" color="#ffffff" />}
                                colorText="#cbb353"
                                spaceBetween={true}
                            />
                            <LinkPersonalizado7
                                href="/deeborah_martinns/procedimentos"
                                title="PROCEDIMENTOS"
                                icon={<MagazineIcon height="34" color="#ffffff" />}
                                colorText="#cbb353"
                                spaceBetween={true}
                                linkInterno={true}
                            />
                        </>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Deeborah_martinns;
